import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchRequest } from "./store/actions";
import ReactDataTable from "../../components/PrimaryTable";
import { Box } from "@chakra-ui/react";
import Layout from "../../layout";
import Selector from "./components/Selector";
import DataTableColumns from "../../components/DataTableColumns";
import { fetchPatientDetailsRequest } from "../ips/ipsStore/actions";

const SearchResults = () => {
  const dispatch = useDispatch();

  const { searchSectionResponse } = useSelector((state) => state.search);
  const { patientDetails } = useSelector((state) => state.ips);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);

  useEffect(() => {
    let payload = {
      query: localStorage.getItem("search_query"),
      section: localStorage.getItem("search_section"),
    };
    // dispatch(resetTrdetails());
    dispatch(searchRequest(payload));
  }, []);

  useEffect(() => {
    if (patientDetails && patientDetails.length > 0) {
      setIsModalOpen(true);
    }
  }, [patientDetails]);

  const handleViewClick = (id) => {
    let payload = {
      tr_id: id,
      source: "Web",
    };
    setSelectedPatient(id);
    dispatch(fetchPatientDetailsRequest(payload));
  };

  const options_map = {
    "TR-ID": "tr_id",
    "Patient Name": "patient_name",
    "Passport Number": "passport_no",
    Hospitals: "hospital",
    "Health Concern": "health_concern",
    Country: "country",
  };

  const reverse_options_map = {
    tr_id: "TR-ID",
    patient_name: "Patient Name",
    passport_no: "Passport Number",
    hospital: "Hospitals",
    health_concern: "Health Concern",
    country: "Country",
  };

  const options = [
    "TR-ID",
    "Patient Name",
    "Passport Number",
    "Hospitals",
    "Health Concern",
    "Country",
  ];

  const handleOptionSelect = (option) => {
    const section = options_map[option];
    localStorage.setItem("search_section", section);

    let payload = {
      query: localStorage.getItem("search_query"),
      section: section,
    };
    dispatch(searchRequest(payload));
  };

  return (
    <Layout header={"Search"} iconUrl="/home">
      <Selector
        options={options}
        buttonColor="secondary.1"
        hoverColor="secondary.1"
        activeColor="secondary.1"
        onOptionSelect={handleOptionSelect}
        marginLeft="68px"
        defaultOption={
          reverse_options_map[localStorage.getItem("search_section")]
        }
      />
      <Box
        minHeight="600px"
        bgColor={"#ffff"}
        mt="20px"
        ml="10px"
        shadow="md"
        borderWidth="1px"
        borderRadius="md"
      >
        <ReactDataTable
          columns={DataTableColumns(handleViewClick)}
          data={searchSectionResponse}
          handleViewClick={handleViewClick}
          selectedPatientId={selectedPatient}
        />
      </Box>
    </Layout>
  );
};

export default SearchResults;
